export class MemoryStorage<T = unknown> {
  #storage: T | null = null;

  getItem(): T | null {
    return this.#storage;
  }

  setItem(value: T) {
    this.#storage = value;
  }
}
